/*!
* FitText.js 1.0 jQuery free version
*
* Copyright 2011, Dave Rupert http://daverupert.com
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
* Modified by Slawomir Kolodziej http://slawekk.info
*
* Date: Tue Aug 09 2011 10:45:54 GMT+0200 (CEST)
*/
const extend = (obj, ext) => {
  const returnObj = obj;
  Object.keys(ext).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(ext, key)) {
      returnObj[key] = ext[key];
    }
  });
  return returnObj;
};

export default function fitText(el, kompressor, options) {
  const settings = extend({
    minFontSize: -1 / 0,
    maxFontSize: 1 / 0,
  }, options);

  const fit = () => {
    const compressor = kompressor || 1;
    const resizer = () => {
      const element = el;
      const fontSize = Math.max(Math.min(
        el.clientWidth / (compressor * 10),
        parseFloat(settings.maxFontSize),
      ), parseFloat(settings.minFontSize));
      element.style.fontSize = `${fontSize}px`;
    };

    // Call once to set.
    resizer();

    // Bind events
    // If you have any js library which support Events, replace this part
    // and remove addEvent function (or use original jQuery version)
    window.addEventListener('resize', resizer);
    window.addEventListener('orientationchange', resizer);
  };

  if (el.length) {
    for (let i = 0; i < el.length; i += 1) {
      fit(el[i]);
    }
  } else {
    fit(el);
  }

  // return set of elements
  return el;
}

export function applyFitText($el) {
  $el.querySelectorAll('.fit-text').forEach(($fitText) => {
    const factor = ($fitText.innerHTML.length / 10);
    fitText($fitText, factor, { minFontSize: 45, maxFontSize: 92 });
  });
}
